import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../App";
import { Loader2, AlertCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const QRResolverPage = () => {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const resolve = async () => {
      try {
        const res = await axios.get(`${API}/qr/resolve/${token}`);
        const { target_path } = res.data;
        if (!user) {
          // Stash and bounce to login
          sessionStorage.setItem("postLoginRedirect", target_path);
          navigate(`/login?next=${encodeURIComponent(target_path)}`, { replace: true });
        } else {
          navigate(target_path, { replace: true });
        }
      } catch (e) {
        setError(e.response?.data?.detail || "Invalid QR code");
      }
    };
    resolve();
  }, [token, user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="text-center" data-testid="qr-resolver">
        {error ? (
          <>
            <AlertCircle className="w-10 h-10 text-red-500 mx-auto mb-2" />
            <p className="font-semibold text-red-700">{error}</p>
            <button onClick={() => navigate("/dashboard")} className="mt-4 px-4 py-2 bg-orange-500 text-white rounded font-semibold">Go to dashboard</button>
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 text-orange-500 animate-spin mx-auto mb-2" />
            <p className="font-semibold text-slate-700">Opening the right page…</p>
          </>
        )}
      </div>
    </div>
  );
};

export default QRResolverPage;
